module.exports = __webpack_public_path__ + "img/Icon - Done or Correct.00d13211.svg";